export default "__VITE_ASSET__jnTESFTf__"